/*import axios from 'axios';

const API_URL = 'https://www.ouicsport.fr/api/authentication';

export const login = (email, password) => {
  return axios.post(`${API_URL}/login`, {
    email,
    password
  });
};

export const register = (lastname, firstname, email, phone, password) => {
    return axios.post(`${API_URL}/register`, {
      lastname,
      firstname,
      email,
      phone,
      password
    });
  };


export const requestPasswordReset = (email) => {
    return axios.post(`${API_URL}/forgotten-password`, {
        email
    });
};



export const resetPassword = (code, password, password2, id) => {
    return axios.post(`${API_URL}/forgotten-password/reset`, {
        code,
        password,
        password2,
        id
    });
};*/

import axios from 'axios';

const API_URL = 'https://www.ouicsport.fr/api/authentication';

export const login = (email, password) => {
  let formData = new FormData();
  formData.append('email', email);
  formData.append('password', password);
  
  return axios.post(`${API_URL}/login`, formData);
};

export const register = (lastname, firstname, email, phone, password) => {
  let formData = new FormData();
  formData.append('lastname', lastname);
  formData.append('firstname', firstname);
  formData.append('email', email);
  formData.append('phone', phone);
  formData.append('password', password);
  
  return axios.post(`${API_URL}/register`, formData);
};

export const requestPasswordReset = (email) => {
  let formData = new FormData();
  formData.append('email', email);
  
  return axios.post(`${API_URL}/forgotten-password`, formData);
};

export const resetPassword = (code, password, password2, id) => {
  let formData = new FormData();
  formData.append('code', code);
  formData.append('password', password);
  formData.append('password2', password2);
  formData.append('id', id);
  
  return axios.post(`${API_URL}/forgotten-password/reset`, formData);
};
